import styled from 'styled-components'
import { iPadDown } from '../../styles/mediaQueries'
import { DolaThemeProps } from '../../styles/types'
import { borderRadius } from '../../styles/variables'

interface StyledWidgetProps extends DolaThemeProps {
  clickable?: boolean
}

export const StyledWidget = styled.div<StyledWidgetProps>`
  background: ${({ dolaTheme }) =>
    dolaTheme === 'light' ? '#FAFAFA' : '#0B0B0B'};
  padding: 1.17vw;
  ${borderRadius};
  ${({ clickable }) => (clickable ? 'cursor: pointer;' : '')}

  ${iPadDown} {
    padding: 3.72vw;
  }

  ${({ dolaTheme }) =>
    dolaTheme === 'light'
      ? ''
      : `
    .widget-separator {
      border-color: #101010;
    }
  `}

  h2 {
    font-size: 1.3vw;
    font-weight: bold;

    ${iPadDown} {
      font-size: 4.5vw;
    }
  }
`

export const WidgetSummaryItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1.17vw;

  ${iPadDown} {
    margin-top: 3.62vw;
  }
`
